<app-vw-kopf [titel]="'verwaltung.bereich.rechner.titel' | translate">
  <span
    vwKopfTitelZusatz
    class="vw-rechner__info"
    data-testid="vw-rechner-info"
    tabindex="0"
    role="img"
    [attr.aria-label]="'verwaltung.rechner.info' | translate"
    [attr.title]="'verwaltung.rechner.info' | translate"
  >
    i
  </span>
  <!-- Ohne Zeilenumbrüche, sonst steht ein sichtbares Leerzeichen vor dem Punkt -->
  <!-- prettier-ignore -->
  <span vwKopfUntertitel
    >{{ 'verwaltung.rechner.untertitelVorLink' | translate
    }}<a class="vw-rechner__link" routerLink="/runners" data-testid="vw-rechner-verwalten-link">{{
      'verwaltung.rechner.verwalten' | translate
    }}</a>{{ 'verwaltung.rechner.untertitelNachLink' | translate }}</span
  >
</app-vw-kopf>

<div class="vw-rechner__karte">
  <div
    class="vw-rechner__tabelle"
    role="table"
    data-testid="vw-rechner-tabelle"
    [attr.aria-label]="'verwaltung.rechner.tabelle' | translate"
  >
    <div class="vw-rechner__raster vw-rechner__kopf" role="row">
      <span role="columnheader">{{ 'verwaltung.rechner.spalte.rechner' | translate }}</span>
      <span role="columnheader">{{ 'verwaltung.rechner.spalte.zustand' | translate }}</span>
      <span role="columnheader">{{ 'verwaltung.rechner.spalte.werkzeug' | translate }}</span>
      <span role="columnheader">{{ 'verwaltung.rechner.spalte.einrichter' | translate }}</span>
      <span role="columnheader">{{ 'verwaltung.rechner.spalte.projekte' | translate }}</span>
    </div>
    @for (z of zeilen(); track z.id) {
      <div class="vw-rechner__raster vw-rechner__zeile" role="row" data-testid="vw-rechner-zeile">
        <div class="vw-rechner__rechner" role="cell">
          <div class="vw-rechner__name" data-testid="vw-rechner-name" [attr.title]="z.name">{{ z.name }}</div>
          @if (z.etiketten) {
            <div class="vw-rechner__etiketten" data-testid="vw-rechner-etiketten">{{ z.etiketten }}</div>
          }
        </div>
        <div role="cell">
          <span class="vw-rechner__zustand vw-rechner__zustand--{{ z.zustand }}" data-testid="vw-rechner-zustand">
            <span class="vw-rechner__punkt" aria-hidden="true"></span>
            {{ 'verwaltung.rechner.zustand.' + z.zustand | translate }}
          </span>
          @if (z.zuletzt) {
            <div class="vw-rechner__zuletzt" data-testid="vw-rechner-zuletzt">
              {{ 'verwaltung.rechner.zuletzt' | translate: { datum: z.zuletzt } }}
            </div>
          }
        </div>
        <span class="vw-rechner__werkzeug" role="cell" data-testid="vw-rechner-werkzeug">{{ z.werkzeug }}</span>
        <span class="vw-rechner__einrichter" role="cell" data-testid="vw-rechner-einrichter">
          @if (z.einrichter; as name) {
            <span class="vw-rechner__avatar" aria-hidden="true"><app-avatar [name]="name" [size]="26" /></span>
            <span class="vw-rechner__einrichter-name">{{ name }}</span>
          } @else {
            —
          }
        </span>
        <span class="vw-rechner__projekte" role="cell" data-testid="vw-rechner-projekte">
          {{ 'verwaltung.rechner.alleProjekte' | translate }}
        </span>
      </div>
    }
  </div>

  @switch (store.rechnerStatus()) {
    @case ('laedt') {
      <div class="vw-rechner__hinweis" role="status" data-testid="vw-rechner-laden">
        {{ 'verwaltung.rechner.laden' | translate }}
      </div>
    }
    @case ('fehler') {
      <div class="vw-rechner__hinweis vw-rechner__hinweis--fehler" role="alert" data-testid="vw-rechner-fehler">
        <p class="vw-rechner__fehlertext">{{ 'verwaltung.rechner.fehler' | translate }}</p>
        <button mat-stroked-button type="button" data-testid="vw-rechner-erneut" (click)="store.rechnerAktualisieren()">
          {{ 'verwaltung.rechner.erneut' | translate }}
        </button>
      </div>
    }
    @default {
      @if (zeilen().length === 0) {
        <div class="vw-rechner__hinweis" data-testid="vw-rechner-leer">
          {{ 'verwaltung.rechner.leer' | translate }}
        </div>
      }
    }
  }
</div>
